// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   TextField,
//   Typography,
//   Paper,
//   Alert,
//   Stack,
//   Grid,
//   IconButton,
//   InputAdornment,
//   CircularProgress
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import CryptoJS from "crypto-js";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import logo from "../../../Assets/logo.png";

// const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

// const LoginPage = () => {

//   const [loginType, setLoginType] = useState("password");
//   const [showPassword, setShowPassword] = useState(false);

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [otp, setOtp] = useState("");

//   const [otpRequested, setOtpRequested] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   /* -------------------- Encryption Helpers -------------------- */

//   const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(data, secretKey).toString();
//   };

//   const encryptJSON = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
//   };

//   /* -------------------- Save Session -------------------- */

//   const saveLoginSession = (data) => {

//     sessionStorage.setItem(
//       "LoginUserAccessToken",
//       encryptData(data.access)
//     );

//     sessionStorage.setItem(
//       "LoginUserRefreshToken",
//       encryptData(data.refresh)
//     );

//     sessionStorage.setItem(
//       "LoginUserType",
//       encryptData(data.user.user_type || "admin")
//     );

//     sessionStorage.setItem(
//       "LoginUserDetails",
//       encryptJSON(data.user)
//     );
//   };

//   /* -------------------- Role Navigation -------------------- */

//   const redirectUserByRole = (role) => {

//     switch (role) {

//       case "super_admin":
//       case "admin":
//       case "developer":
//       case "":
//         window.location.href = "/rite-admin/dashboard";
//         break;

//       case "manager":
//         window.location.href = "/rite-manager/dashboard";
//         break;

//       case "marketer":
//         window.location.href = "/rite-marketer/dashboard";
//         break;

//       case "staff":
//         window.location.href = "/rite-staff/dashboard";
//         break;

//       default:
//         window.location.href = "/rite-admin/dashboard";
//     }
//   };

//   /* -------------------- Password Login -------------------- */

//   const handlePasswordLogin = async () => {

//     setError("");
//     setLoading(true);

//     try {

//       const response = await ApiServices.post("/api/v1/auth/login/", {
//         email,
//         password
//       });

//       const data = response.data;

//       saveLoginSession(data);

//       redirectUserByRole(data.user.user_type);

//     } catch (err) {

//       const message =
//         err?.response?.data?.non_field_errors?.[0] ||
//         "Invalid email or password";

//       setError(message);
//     }

//     setLoading(false);
//   };

//   /* -------------------- Request OTP -------------------- */

//   const requestOTP = async () => {

//     setError("");
//     setLoading(true);

//     try {

//       await ApiServices.post("/api/v1/auth/otp/request/", {
//         email
//       });

//       setOtpRequested(true);

//     } catch (err) {

//       const message =
//         err?.response?.data?.email?.[0] ||
//         err?.response?.data?.detail ||
//         "Failed to send OTP";

//       setError(message);
//     }

//     setLoading(false);
//   };

//   /* -------------------- Verify OTP -------------------- */

//   const verifyOTP = async () => {

//     setError("");
//     setLoading(true);

//     try {

//       const response = await ApiServices.post(
//         "/api/v1/auth/otp/verify/",
//         {
//           email,
//           otp
//         }
//       );

//       const data = response.data;

//       saveLoginSession(data);

//       redirectUserByRole(data.user.user_type);

//     } catch (err) {

//       const message =
//         err?.response?.data?.otp?.[0] ||
//         "Invalid OTP";

//       setError(message);

//       if (
//         message.includes("expired") ||
//         message.includes("Too many")
//       ) {
//         setOtpRequested(false);
//       }
//     }

//     setLoading(false);
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "calc(100dvh - 80px)",
//         background:
//           "linear-gradient(135deg,#0f2027,#203a43,#2c5364)",
//         display: "flex",
//         alignItems: "center",
//         position: "relative",
//         overflow: "hidden"
//       }}
//     >

//       {/* 3D Background */}
//       <Box
//         sx={{
//           position: "absolute",
//           width: 500,
//           height: 500,
//           background: "radial-gradient(circle,#1976d2,transparent)",
//           borderRadius: "50%",
//           top: -150,
//           left: -150,
//           filter: "blur(120px)",
//           opacity: 0.6
//         }}
//       />

//       <Box
//         sx={{
//           position: "absolute",
//           width: 500,
//           height: 500,
//           background: "radial-gradient(circle,#00c6ff,transparent)",
//           borderRadius: "50%",
//           bottom: -150,
//           right: -150,
//           filter: "blur(120px)",
//           opacity: 0.6
//         }}
//       />

//       <Container maxWidth="lg">
//         <Grid container spacing={6} alignItems="center">

//           {/* Branding */}
//           <Grid item md={6} sx={{ display: { xs: "none", md: "block" } }}>

//             <Typography
//               variant="h3"
//               fontWeight={700}
//               color="white"
//             >
//               Rite Marketing
//               <br />
//               Automation Platform
//             </Typography>

//             <Typography
//               variant="h6"
//               color="rgba(255,255,255,0.8)"
//               sx={{ mt: 2 }}
//             >
//               Automate marketing, manage customers,
//               accept orders & bookings, and grow
//               your business with AI-powered tools.
//             </Typography>

//           </Grid>

//           {/* Login Card */}
//           <Grid item xs={12} md={6}>

//             <Paper
//               elevation={10}
//               sx={{
//                 p: 5,
//                 borderRadius: 4,
//                 backdropFilter: "blur(10px)",
//                 background: "rgba(255,255,255,0.95)"
//               }}
//             >

//               <Box textAlign="center" mb={3}>
//                 <Box
//                   component="img"
//                   src={logo}
//                   alt="Rite Marketing"
//                   sx={{ height: 60 }}
//                 />
//               </Box>

//               <Typography
//                 variant="h4"
//                 fontWeight={700}
//                 align="center"
//               >
//                 Welcome Back
//               </Typography>

//               <Typography
//                 align="center"
//                 color="text.secondary"
//                 mb={4}
//               >
//                 Login to your dashboard
//               </Typography>

//               {error && (
//                 <Alert severity="error" sx={{ mb: 2 }}>
//                   {error}
//                 </Alert>
//               )}

//               <Stack spacing={3}>

//                 <TextField
//                   label="Email"
//                   fullWidth
//                   value={email}
//                   onChange={(e) =>
//                     setEmail(e.target.value)
//                   }
//                 />

//                 {loginType === "password" && (
//                   <TextField
//                     label="Password"
//                     type={showPassword ? "text" : "password"}
//                     fullWidth
//                     value={password}
//                     onChange={(e) =>
//                       setPassword(e.target.value)
//                     }
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() =>
//                               setShowPassword(!showPassword)
//                             }
//                           >
//                             {showPassword ? (
//                               <VisibilityOff />
//                             ) : (
//                               <Visibility />
//                             )}
//                           </IconButton>
//                         </InputAdornment>
//                       )
//                     }}
//                   />
//                 )}

//                 {loginType === "otp" && otpRequested && (
//                   <TextField
//                     label="Enter OTP"
//                     fullWidth
//                     value={otp}
//                     onChange={(e) =>
//                       setOtp(e.target.value)
//                     }
//                   />
//                 )}

//                 {loginType === "password" && (
//                   <Button
//                     variant="contained"
//                     size="large"
//                     onClick={handlePasswordLogin}
//                     disabled={loading}
//                     sx={{
//                       background:
//                         "linear-gradient(135deg,#094C9F,#1976d2)",
//                       py: 1.5
//                     }}
//                   >
//                     {loading ? (
//                       <CircularProgress size={22} />
//                     ) : (
//                       "Login"
//                     )}
//                   </Button>
//                 )}

//                 {loginType === "otp" && !otpRequested && (
//                   <Button
//                     variant="contained"
//                     size="large"
//                     onClick={requestOTP}
//                     sx={{
//                       background:
//                         "linear-gradient(135deg,#094C9F,#1976d2)"
//                     }}
//                   >
//                     Send OTP
//                   </Button>
//                 )}

//                 {loginType === "otp" && otpRequested && (
//                   <Button
//                     variant="contained"
//                     size="large"
//                     onClick={verifyOTP}
//                     sx={{
//                       background:
//                         "linear-gradient(135deg,#094C9F,#1976d2)"
//                     }}
//                   >
//                     Verify OTP
//                   </Button>
//                 )}

//                 <Button
//                   variant="text"
//                   onClick={() =>
//                     setLoginType(
//                       loginType === "password"
//                         ? "otp"
//                         : "password"
//                     )
//                   }
//                 >
//                   {loginType === "password"
//                     ? "Login with OTP instead"
//                     : "Login with Password instead"}
//                 </Button>

//               </Stack>

//             </Paper>
//           </Grid>
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// export default LoginPage;


import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Alert,
  Stack,
  Grid,
  IconButton,
  InputAdornment,
  CircularProgress,
  Chip,
} from "@mui/material";
import { Visibility, VisibilityOff, AdminPanelSettings, Security, Speed } from "@mui/icons-material";
import CryptoJS from "crypto-js";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import logo from "../../../Assets/logo.png";

const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;
const accent = "#1a3d3b";

const btnSx = {
  backgroundColor: accent,
  borderRadius: "12px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "1rem",
  py: 1.5,
  boxShadow: "0 4px 14px rgba(26,61,59,0.25)",
  transition: "all 0.25s ease",
  "&:hover": {
    backgroundColor: "#15302e",
    transform: "translateY(-1px)",
    boxShadow: "0 6px 20px rgba(26,61,59,0.35)",
  },
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fafbfc",
    transition: "all 0.2s ease",
    "& fieldset": { borderColor: "#e0e0e0" },
    "&:hover fieldset": { borderColor: accent },
    "&.Mui-focused fieldset": { borderColor: accent, borderWidth: 2 },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent },
};

const features = [
  { icon: <AdminPanelSettings sx={{ color: accent, fontSize: 28 }} />, title: "Role-Based Access", desc: "Admin, Manager, Marketer & Staff dashboards" },
  { icon: <Security sx={{ color: accent, fontSize: 28 }} />, title: "Secure Login", desc: "Encrypted sessions with OTP verification" },
  { icon: <Speed sx={{ color: accent, fontSize: 28 }} />, title: "Real-Time Analytics", desc: "Monitor campaigns, orders & performance live" },
];

const LoginPage = () => {
  const [loginType, setLoginType] = useState("password");
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [otpRequested, setOtpRequested] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const encryptData = (data) => CryptoJS.AES.encrypt(data, secretKey).toString();
  const encryptJSON = (data) => CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();

  const saveLoginSession = (data) => {
    sessionStorage.setItem("LoginUserAccessToken", encryptData(data.access));
    sessionStorage.setItem("LoginUserRefreshToken", encryptData(data.refresh));
    sessionStorage.setItem("LoginUserType", encryptData(data.user.user_type || "admin"));
    sessionStorage.setItem("LoginUserDetails", encryptJSON(data.user));
  };

  const redirectUserByRole = (role) => {
    switch (role) {
      case "super_admin":
      case "admin":
      case "developer":
      case "":
        window.location.href = "/rite-admin/dashboard";
        break;
      case "manager":
        window.location.href = "/rite-manager/dashboard";
        break;
      case "marketer":
        window.location.href = "/rite-marketer/dashboard";
        break;
      case "staff":
        window.location.href = "/rite-staff/dashboard";
        break;
      default:
        window.location.href = "/rite-admin/dashboard";
    }
  };

  const handlePasswordLogin = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await ApiServices.post("/api/v1/auth/login/", { email, password });
      const data = response.data;
      saveLoginSession(data);
      redirectUserByRole(data.user.user_type);
    } catch (err) {
      const message = err?.response?.data?.non_field_errors?.[0] || "Invalid email or password";
      setError(message);
    }
    setLoading(false);
  };

  const requestOTP = async () => {
    setError("");
    setLoading(true);
    try {
      await ApiServices.post("/api/v1/auth/otp/request/", { email });
      setOtpRequested(true);
    } catch (err) {
      const message = err?.response?.data?.email?.[0] || err?.response?.data?.detail || "Failed to send OTP";
      setError(message);
    }
    setLoading(false);
  };

  const verifyOTP = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await ApiServices.post("/api/v1/auth/otp/verify/", { email, otp });
      const data = response.data;
      saveLoginSession(data);
      redirectUserByRole(data.user.user_type);
    } catch (err) {
      const message = err?.response?.data?.otp?.[0] || "Invalid OTP";
      setError(message);
      if (message.includes("expired") || message.includes("Too many")) {
        setOtpRequested(false);
      }
    }
    setLoading(false);
  };

  const accent = "#0d47a1";
const accentLight = "#e3f2fd";

  return (
    <Box
      sx={{
        minHeight: "91vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${accentLight} 0%, #fff 50%, #e8eaf6 100%)`,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background decorations */}
      <Box
        sx={{
          position: "absolute",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${accent}10 0%, transparent 70%)`,
          top: -200,
          right: -150,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: 450,
          height: 450,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${accent}08 0%, transparent 70%)`,
          bottom: -120,
          left: -100,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${accent}06 0%, transparent 70%)`,
          top: "40%",
          left: "30%",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center" justifyContent="center">
          {/* Branding Panel */}
          <Grid item xs={12} md={5} sx={{ display: { xs: "none", md: "block" } }}>
            <Box sx={{ pr: 4 }}>
              <Chip
                label="Internal Portal"
                size="small"
                sx={{
                  backgroundColor: `${accent}15`,
                  color: accent,
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  mb: 2,
                  borderRadius: "8px",
                }}
              />
              <Typography variant="h3" sx={{ fontWeight: 800, color: accent, lineHeight: 1.2, mb: 0.5 }}>
                Rite Marketing
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 300, color: "#555", mb: 4 }}>
                Staff Dashboard
              </Typography>

              <Stack spacing={3}>
                {features.map((f, i) => (
                  <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "12px",
                        backgroundColor: `${accent}08`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {f.icon}
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#333", mb: 0.3 }}>
                        {f.title}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#888", lineHeight: 1.5 }}>
                        {f.desc}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Stack>
            </Box>
          </Grid>

          {/* Login Card */}
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3.5, sm: 5 },
                borderRadius: "20px",
                border: "1px solid #e8eded",
                boxShadow: "0 20px 60px rgba(26,61,59,0.08)",
                maxWidth: 440,
                mx: "auto",
              }}
            >
              <Box sx={{ textAlign: "center", mb: 4 }}>
                <Box
                  component="img"
                  src={logo}
                  alt="Rite Marketing Logo"
                  sx={{ height: 56, mb: 2, borderRadius: "12px" }}
                />
                <Typography variant="h5" sx={{ fontWeight: 700, color: "#1a1a1a", mb: 0.5 }}>
                  Staff Login
                </Typography>
                <Typography variant="body2" sx={{ color: "#999" }}>
                  Access your internal dashboard
                </Typography>
              </Box>

              {error && (
                <Alert
                  severity="error"
                  onClose={() => setError("")}
                  sx={{ mb: 3, borderRadius: "10px" }}
                >
                  {error}
                </Alert>
              )}

              <Stack spacing={2.5}>
                <TextField
                  fullWidth
                  label="Work Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={inputSx}
                />

                {loginType === "password" && (
                  <TextField
                    fullWidth
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={inputSx}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}

                {loginType === "otp" && otpRequested && (
                  <TextField
                    fullWidth
                    label="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    sx={inputSx}
                    helperText="Check your work email for the verification code"
                  />
                )}

                {loginType === "password" && (
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={handlePasswordLogin}
                    disabled={loading}
                    sx={btnSx}
                  >
                    {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Sign In"}
                  </Button>
                )}

                {loginType === "otp" && !otpRequested && (
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={requestOTP}
                    disabled={loading}
                    sx={btnSx}
                  >
                    {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Send OTP"}
                  </Button>
                )}

                {loginType === "otp" && otpRequested && (
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={verifyOTP}
                    disabled={loading}
                    sx={btnSx}
                  >
                    {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Verify & Sign In"}
                  </Button>
                )}

                <Button
                  fullWidth
                  variant="text"
                  onClick={() => {
                    setLoginType(loginType === "password" ? "otp" : "password");
                    setOtpRequested(false);
                    setError("");
                  }}
                  sx={{
                    textTransform: "none",
                    color: accent,
                    fontWeight: 500,
                    fontSize: "0.875rem",
                    "&:hover": { backgroundColor: `${accent}08` },
                  }}
                >
                  {loginType === "password" ? "Use OTP verification instead" : "Use password instead"}
                </Button>
              </Stack>

              <Typography
                variant="caption"
                sx={{ display: "block", textAlign: "center", color: "#bbb", mt: 4 }}
              >
                Authorized personnel only · © {new Date().getFullYear()} Rite Marketing
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LoginPage;
